import { schema } from "normalizr";

const taskList = new schema.Entity(`task_lists`);
const arrayOfTaskLists = [taskList];

export { taskList, arrayOfTaskLists };
